var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import IconContainer from "../IconContainer";
const OutlookIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (React.createElement(IconContainer, Object.assign({ className: classNames("gerudo-icon-outlook", size, className) }, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "23.738", height: "24", viewBox: "0 0 23.738 24", role: "img", "aria-label": title },
            React.createElement("path", { fill: "currentColor", stroke: "none", role: "presentation", id: "path3", d: "M14.855,5.088V9.783L16.5,10.816a.405.405,0,0,0,.18,0l7.061-4.76a1.007,1.007,0,0,0-.822-.968Z" }),
            React.createElement("path", { fill: "currentColor", stroke: "none", role: "presentation", id: "path5", d: "M14.855,11.534l1.5,1.029a.449.449,0,0,0,.466,0c-.254.155,6.92-4.61,6.92-4.61v8.628a1.208,1.208,0,0,1-1.278,1.334H14.854V11.534Z" }),
            React.createElement("g", { id: "g23" },
                React.createElement("path", { fill: "currentColor", stroke: "none", role: "presentation", id: "path25", d: "M7.1,9.37a1.379,1.379,0,0,0-1.217.719,3.54,3.54,0,0,0-.451,1.9,3.472,3.472,0,0,0,.451,1.9,1.368,1.368,0,0,0,2.375.019A3.441,3.441,0,0,0,8.7,12.023a3.743,3.743,0,0,0-.428-1.955A1.317,1.317,0,0,0,7.1,9.37Z" }),
                React.createElement("path", { fill: "currentColor", stroke: "none", role: "presentation", id: "path27", d: "M0,2.7V21.07L13.972,24V0ZM9.349,14.992a2.769,2.769,0,0,1-2.31,1.167,2.732,2.732,0,0,1-2.262-1.13A4.673,4.673,0,0,1,3.9,12.085a5.032,5.032,0,0,1,.888-3.1A2.8,2.8,0,0,1,7.143,7.8,2.669,2.669,0,0,1,9.38,8.935a4.83,4.83,0,0,1,.855,2.986A4.942,4.942,0,0,1,9.349,14.992Z" })))));
};
OutlookIcon.defaultProps = {
    title: "Outlook icon",
};
export default OutlookIcon;
export { OutlookIcon };
//# sourceMappingURL=Outlook.js.map